import assign = require('object-assign');
import { FETCH_REQUEST, FETCH_SUCCESS, FETCH_FAILURE } from '../constants/Tag';

import { ITagState } from '../interfaces/states';
import { Tag } from '../store/models';
import translate from '../locale/translate';

const initialState: ITagState = {
    byId: {},
    arr: []
};

translate.gettext('server');
translate.gettext('workstation');
translate.gettext('backup');
translate.gettext('Email');
translate.gettext('Database');
translate.gettext('hardware');
translate.gettext('Network');
translate.gettext('Operating System');
translate.gettext('storage');
translate.gettext('virtual');
translate.gettext('environment');
translate.gettext('logfiles');
translate.gettext('templates');

function formatTag(tag: Tag): Tag {
    if (tag.readonly) {
        tag.name = translate.gettext(tag.name);
    }
    return tag;
}

function formatTags(tags: Tag[]): Tag[] {
    return tags.map(formatTag);
}

export default function states(state = initialState, action): ITagState {
    switch (action.type) {
        case FETCH_REQUEST: {
            return assign({}, state, {
                loading: true
            });
        }
        case FETCH_SUCCESS: {
            const byId = assign({}, state.byId);
            const arr = [
                ...state.arr
            ];

            const tags = action.payload;

            tags.forEach(tag => {
                tag = formatTag(tag);
                byId[tag.tId] = tag;
                arr.push(tag.tId);
            });

            return assign({}, state, {
                loading: false,
                byId,
                arr
            });
        }
        case FETCH_FAILURE: {
            return assign({}, state, {
                loading: false,
                error: action.error
            });
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/tags.ts